import { render, staticRenderFns } from "./AdminLicenses.vue?vue&type=template&id=311b2968&scoped=true&"
import script from "./AdminLicenses.vue?vue&type=script&lang=js&"
export * from "./AdminLicenses.vue?vue&type=script&lang=js&"
import style0 from "./AdminLicenses.vue?vue&type=style&index=0&id=311b2968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b2968",
  null
  
)

export default component.exports